<template>
  <div class="flex flex-col flex-1">
    <h1 class="text-sm font-light p-2 text-center rounded-t-lg" :class="labelClass">{{ label }}</h1>
    <div
      class="flex flex-col gap-6 p-3 relative rounded-b-lg"
      :style="`background-image: url('/maps/${map?.map_name?.toLowerCase()}_xl.jpeg'); background-size: cover; background-position: center; background-repeat: no-repeat; width: 100%; height: 100%;`"
    >
      <div class="absolute top-0 left-0 w-full h-full bg-black image-gradient opacity-90" />
      <div class="flex gap-3 z-50 items-center">
        <img :src="`/maps/map_icon_${map?.map_name?.toLowerCase()}.svg`" class="w-10 h-10" />
        <h1 class="text-text-primary">{{ map?.map_name_friendly || map?.map_name }}</h1>
      </div>
      <div class="flex flex-col gap-3 z-50">
        <div class="flex gap-2 flex-1">
          <h1 class="text-text-secondary flex-1 text-sm">{{ $t('common.matches') }}</h1>
          <h1 class="text-text-primary">{{ map?.matches_played }}</h1>
        </div>
        <div class="flex gap-2 flex-1">
          <h1 class="text-text-secondary flex-1 text-sm">{{ $t('coach.maps.win_rate') }}</h1>
          <h1 class="text-text-primary">{{ ((map?.winrate ?? 0) * 100).toFixed(0) }}%</h1>
        </div>
      </div>
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps({
  map: Object,
  label: String,
  labelClass: String,
});
</script>

<style scoped>
.image-gradient {
  background: linear-gradient(180deg, rgba(15, 19, 26, 0.90) 0%, #0F131A 50%, #0F131A 100%);
}
</style>
